export const Name = 'qcDocumentsComponent';
